var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRegistrationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3944 29.85H3.96109C3.13597 29.85 2.34465 29.5284 1.7612 28.956C1.17775 28.3835 0.849977 27.6071 0.849977 26.7976V13.0619C0.849606 12.6173 0.948257 12.1779 1.13903 11.7746C1.3298 11.3713 1.60809 11.0137 1.95442 10.7269L12.8433 1.56978C13.4046 1.10496 14.1155 0.849976 14.85 0.849976C15.5845 0.849976 16.2953 1.10496 16.8566 1.56978L27.7455 10.7269C28.0919 11.0137 28.3702 11.3713 28.5609 11.7746C28.7517 12.1779 28.8503 12.6173 28.85 13.0619V16.6485M19.2055 16.7248C19.0606 16.5352 18.8728 16.3814 18.6568 16.2754C18.4408 16.1695 18.2026 16.1143 17.9611 16.1143H11.7389C11.3263 16.1143 10.9306 16.2751 10.6389 16.5613C10.3472 16.8475 10.1833 17.2357 10.1833 17.6405V29.85M19.5166 25.2714H28.85M24.1833 20.6929V29.85",
    stroke: "#306BFF",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRegistrationIcon);
export default __webpack_public_path__ + "static/media/new-registration-icon.6b944c0043bfbbf2313da7933c2a1f9a.svg";
export { ForwardRef as ReactComponent };